import { RootState } from '@/typings';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export const initialState: RootState = {
	themeName: 'default',
	permissions: ['*'],
	userMenu: [],
	activeUrl: '',
	showAnnounce: true,
	versionUsage: {},
	appConfig: {},
};

export const counterSlice = createSlice({
	name: 'sys',
	initialState,
	reducers: {
		setActiveIndex: (state, { payload }: PayloadAction<RootState['activeIndex']>) => {
			state.activeIndex = payload;
		},
		setActiveUrl: (state, { payload }: PayloadAction<RootState['activeUrl']>) => {
			state.activeUrl = payload;
		},
		setThemeName: (state, { payload }: PayloadAction<RootState['themeName']>) => {
			state.themeName = payload;
		},
		setPermissions: (state, { payload }: PayloadAction<RootState['permissions']>) => {
			state.permissions = payload;
		},
		setUserMenu: (state, { payload }: PayloadAction<RootState['userMenu']>) => {
			state.userMenu = payload;
		},
		setUser: (state, { payload }: PayloadAction<RootState['user']>) => {
			state.user = payload;
		},
		setVersionUsage: (state, { payload }: PayloadAction<RootState['versionUsage']>) => {
			state.versionUsage = payload;
		},
		setAppConfig: (state, { payload }: PayloadAction<RootState['appConfig']>) => {
			state.appConfig = payload;
		},
		initSys: (state, { payload }: PayloadAction<RootState>) => {
			state = { ...state, ...payload };
		},
	},
});

export const { setActiveIndex, setActiveUrl, setThemeName, setUserMenu, initSys, setPermissions, setUser, setVersionUsage, setAppConfig } = counterSlice.actions;

export default counterSlice.reducer;
